<template>
  <div>
    <ts-card>
      <div
        class="
          form-header
          ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative
        "
      >
        <h4 class="ts-text-sm">
          {{
            $t('school.academic.operation.profile_mgt.studentProfile.pageTitle')
          }}
        </h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.status'
                  )
                }}
              </label>
              <div>
                <ts-loading-banner :loading="loadingPreData">
                  <treeselect
                    :options="
                      studentStatus.map((i) => ({
                        id: i.status_id,
                        label: i.status,
                      }))
                    "
                    :placeholder="$t('studentprofile.typeforsearch')"
                    v-model="model.status_id"
                  ></treeselect>
                </ts-loading-banner>
                <div class="validate" v-if="errors.has('status_id')">
                  {{ errors.first('status_id') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label
                class="col-form-label control-label"
                :class="model.status_id == 1 ? '' : 'required'"
              >
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.effectiveDate'
                  )
                }}
              </label>
              <div>
                <ts-date-picker-input v-model="model.status_effective_date" />
                <div
                  v-if="errors.has('status_effective_date')"
                  class="validate"
                >
                  {{ errors.first('status_effective_date') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label
                class="col-form-label control-label"
                :class="model.status_id == 1 ? '' : 'required'"
              >
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.reason'
                  )
                }}
              </label>
              <div>
                <textarea
                  v-model="model.status_reason"
                  rows="3"
                  class="form-control"
                  :class="{
                    'is-invalid': errors.has('status_reason'),
                  }"
                ></textarea>
                <div
                  class="invalid-feedback"
                  v-if="errors.has('status_reason')"
                >
                  {{ errors.first('status_reason') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button
              class="btn-sm"
              @click.prevent="$emit('close')"
              :disabled="saving"
              >{{ $t('no') }}</ts-button
            >
            <ts-button
              color="primary"
              class="ml-2 btn-sm"
              :waiting="saving"
              @click.prevent="updateStatus"
              >{{ $t('yes') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  props: ['data'],
  name: 'student-profile-status-form',
  data() {
    return {
      model: {
        student_id: [],
        status_id: '',
        status_effective_date: '',
        status_reason: '',
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false,
    }
  },
  computed: {
    ...mapState('studentProfile', ['studentStatus']),
  },
  created() {
    this.fetchResourceBeforeCreate()
  },
  methods: {
    async fetchResourceBeforeCreate() {
      this.loadingPreData = true
      await this.$store
        .dispatch('studentProfile/getStudentStatus')
        .then(() => {
          this.setData()
          this.loadingPreData = false
        })
        .catch((error) => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    setData() {
      if (this.data.student_id) {
        this.model.student_id.push(this.data.student_id)
        this.model.status_id = this.data.status_id
        this.model.status_effective_date = this.data.status_effective_date
        this.model.status_reason = this.data.status_reason
      } else {
        this.model.student_id = this.data
        this.model.status_id = 1
      }
    },
    async updateStatus() {
      this.errors = new Errors()
      this.saving = true

      this.$store
        .dispatch('studentProfile/updateStatus', this.model)
        .then((response) => {
          return this.$store.dispatch('studentProfile/fetch').then((res) => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
            return Promise.resolve(res)
          })
        })
        .catch((error) => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
  },
}
</script>
